import { useMemo } from 'react';
import { createSelector } from 'reselect';
import { useSelector } from 'react-redux';
import Global from '../store/global-selectors';
import { getDisplayInformation } from '../components/data-driven-logo/get-display-information';

export const useSellerLabelProviders = (labelProviderId) => {
  const sellerLabelProviders = useSelector(Global.selectSellerLabelProviders);
  return useMemo(() => {
    return sellerLabelProviders.filter((sellerLabelProvider) => {
      return !labelProviderId || sellerLabelProvider.labelProviderId === labelProviderId;
    });
  }, [sellerLabelProviders, labelProviderId]);
};

const selectNonWalletedSellerLabelProviders = createSelector(Global.selectSellerLabelProviders, (slps) => slps.filter((p) => !p.walletId));
export const selectActiveNonWalletedSellerLabelProviders = createSelector(selectNonWalletedSellerLabelProviders, (slps) =>
  slps.filter((p) => p.status === 'Active'),
);

const selectNonWalletedAndNonExcludedSellerLabelProviders = createSelector(Global.selectSellerLabelProviders, (slps) =>
  slps.filter((p) => !p.walletId && !getDisplayInformation({ providerId: p.labelProviderId })?.isAlwaysAllowed),
);
export const useNonWalletedAndNonExcludedSellerLabelProviders = () => {
  const nonWalletedAndNonExcludedSellerLabelProviders = useSelector(selectNonWalletedAndNonExcludedSellerLabelProviders);
  return nonWalletedAndNonExcludedSellerLabelProviders;
};

const selectNonWalletedAlwaysAllowedSellerLabelProviders = createSelector(Global.selectSellerLabelProviders, (slps) =>
  slps.filter((p) => !p.walletId && getDisplayInformation({ providerId: p.labelProviderId })?.isAlwaysAllowed),
);
export const useHasNonWalletedAlwaysAllowedProviders = () => {
  const nonWalletedAlwaysAllowedSellerLabelProviders = useSelector(selectNonWalletedAlwaysAllowedSellerLabelProviders);
  return !!nonWalletedAlwaysAllowedSellerLabelProviders?.length;
};
